import React, { useEffect } from 'react'
import Navbar from 'src/components/Navbar/Navbar'
import Footer from 'src/components/Footer/Footer'
import PostGraduateInauguralClassContent from 'src/components/PostGraduationContent/PostGraduationDetails/InauguralClass/PostGraduateInauguralClassContent'

const InauguralClass = () => {
  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    })
  }, [])

  return (
    <>
      <Navbar />
      <PostGraduateInauguralClassContent />
      <Footer />
    </>
  )
}

export default InauguralClass
